import React, { useEffect, useRef, useState } from "react";
import Mark from "mark.js";
import styles from "./markedText.module.css";

interface MarkedTextProps {
  children: string;
  textToMark: string;
}
export const MarkedText = ({ children, textToMark }: MarkedTextProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [mark, setMark] = useState<Mark>();

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const markInstance = new Mark(ref.current);
    setMark(markInstance);
  }, [ref.current]);

  useEffect(() => {
    if (!mark) {
      return;
    }
    mark.mark(textToMark);
  }, [mark, textToMark]);

  return <span ref={ref} className={styles.markedText}>{children}</span>;
};
